import { Dialog,  Grid, Button, DialogTitle } from "@material-ui/core";
import { DocumentacionComunicacionConEmpresas } from "./DocumentacionComunicacionConEmpresas";
export const ModalDocumentacionComunicacion = (props) => {
    return (
        <Dialog
            fullWidth
            maxWidth={"lg"}
            open={props.open}
        >
            <Grid style={{ overflowX: "auto", marginTop: '1rem', padding: '0.5rem' }}>
                <DialogTitle>Documentación</DialogTitle>
                <DocumentacionComunicacionConEmpresas cuit={props.cuit} />
            </Grid>
            <Grid style={{margin:'1rem'}}>
                <Button
                    variant="contained"
                    onClick={props.closeModalHandler}
                    color='primary'
                    style={{textAlign:'center', display:'flex', margin:'auto'}}
                >
                    Cerrar
                </Button>
            </Grid>
        </Dialog>
    )
}